import { Alert, Snackbar, Switch } from '@mui/material';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router';


import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl/FormikControl';

import { Edit } from '@mui/icons-material';


import CommonLoadingSkeleton from '../../../components/CommonLoadingSkeleton';
import ExpandableCard from '../../../components/ExpandableCard'
import AppLayout from '../../../layout/components/AppLayout'
import QueueLayout from '../components/QueueLayout'
import queueServices from '../queueServices';
import queueUpdateServices from '../queueUpdateServices';
import ConfirmDialog from '../../../components/ConfirmDialog';



const ServiceForm = ({queueId,businessId, alertHandler, refreshList, data=null})=>{

    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);



    const initialValues = {
        queueId: queueId,
        businessId:businessId,
        title : "",
        
    }

    const onSubmit = (values, onSubmitProps) => {
        queueUpdateServices.updateBusinessService(values).then(res => {
            refreshList();
            alertHandler(res.msg);
            setDialogStatus(false);
        }).catch(error => {
            alertHandler(error.msg,"error");
        })
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        
    });


    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            businessId:businessId,
            title : data.title,
            
        }
        setFormValues(autoFill);
        
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    return (
        <>
            {!data && <button className="btn btn-primary" onClick={addNew}> Add Service</button>}
            {data &&
              <Tooltip title="Update">
                  <IconButton onClick={updateData} style={{padding:"0px"}}>
                      <Edit/>
                  </IconButton>
              </Tooltip>
            }
          
  
              <Dialog
                  open={dialogStatus}
                  keepMounted
                  onClose={handleClose}
                  fullWidth={true}
                  maxWidth="md"
                  aria-describedby="alert-dialog-slide-description"
              >
  
                  <Formik
                      initialValues={formValues || initialValues}
                      validationSchema={validationRule}
                      onSubmit={onSubmit}
                      enableReinitialize validateOnMount
                  >
                      {
                          (formik) => {
                              //console.log(formik.values);
                              return (
                                  <Form>
                                      <DialogTitle>{"Service"}</DialogTitle>
                                      <DialogContent>
                                          <div className="row p-2">
                                              
                                              <div className="col-md-12">
  
                                                  <div className="row">
                                                      
  
                                                      <FormikControl control="input" formik={formik} type="text" 
                                                          label="Service Name" name="title" 
                                                          className="col-md-4 col-xs-12 p-2" 
                                                      />

                                                        
                                                      
  
                                                  </div>
  
                                              </div>
                                          </div>
  
                                          <div className="row">
                                          { /*  JSON.stringify(formik.values) */}
                                          </div>
  
                                          
                                      </DialogContent>
                                      <DialogActions>
                                          
                                          {savingInProgress && <div className="row"><LinearProgress/></div> }
                                          {!savingInProgress && 
                                              <>
                                              <button className="btn btn-success" type="submit">Save</button>
                                              <button className="btn btn-danger" type="button" onClick={handleClose}>Cancel</button>
                                              </>
                                          }
                                          
                                      </DialogActions>
                                  </Form>
                              )
                          }
                      }
                  </Formik>
              </Dialog>
        </>
      )
}



export default function BusinessServicePage() {

    let { id } = useParams();

    const [loading,setLoadingStatus] = useState(false);
    const [queueConfig,setQueueConfig] = useState(null);

    const [snackStatus, setSnackStatus] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackType, setSnackType] = useState("error");

    const getQueueConfig = useCallback(()=>{
        setLoadingStatus(true);
        queueServices.getQueueConfig(id).then(res=>{
            setQueueConfig(res.data);
        }).catch(error=>{
            setSnackStatus(true);
            setSnackType("error");
            setSnackMessage(error.msg);
        }).finally(()=>{
            setLoadingStatus(false);
        })

    },[id]);

    const alertHandler = (message,messageType="success") =>{
        setSnackStatus(true);
        setSnackType(messageType);
        setSnackMessage(message);
    }

    const remove = (id)=> {
        queueUpdateServices.removeService(id).then(res=>{
            getQueueConfig();
            alertHandler(res.msg)
        }).catch(error =>{
            alertHandler(error.msg,"error")
        })
    }


    useEffect(()=>{
        getQueueConfig();
    },[getQueueConfig])
    

    return (
        <AppLayout>
            <Snackbar open={snackStatus} onClose={ ()=>{setSnackStatus(false)} } autoHideDuration={10000}  anchorOrigin={{ vertical: 'top', horizontal: 'center',  }}>
                <Alert  severity={snackType} sx={{ width: '100%' }}> {snackMessage}</Alert>
            </Snackbar>
            {loading && <CommonLoadingSkeleton/> }
            {queueConfig && queueConfig.businessServices &&
                <QueueLayout queueDetails={queueConfig.queueDetails}>
                    <ExpandableCard title={"Business Services"} defaultOpen={true}>
                        <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="card">
                                            <div className="card-body">
                                                <ServiceForm queueId={id} businessId={queueConfig.queueDetails.businessId} alertHandler={alertHandler} refreshList={getQueueConfig} />
                                            </div>
                                        </div>
                                    </div>
                                    {queueConfig.businessServices.map(businessService=>{
                                        return(
                                            
                                                <div className="col-md-4 mb-3" key={businessService.id}>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-md-8">
                                                                    <p><strong>{businessService.title}</strong> </p> 
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ServiceForm queueId={id} businessId={queueConfig.queueDetails.businessId} alertHandler={alertHandler} refreshList={getQueueConfig} data={businessService} />
                                                                    <ConfirmDialog id={businessService.id} confirm={remove} >Are you Sure You want to remove</ConfirmDialog>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                        )
                                    })}
                                </div>
                        </div>
                    </ExpandableCard>
            
                </QueueLayout>
            }
      </AppLayout>
    )
}

